module.exports = __webpack_public_path__ + "application/directives/text-editor-edit/text-edit-editor.template.html";